
import MuiCardHeader from '@mui/material/CardHeader';

interface IProps {
  title?: React.ReactNode;
  subheader?: React.ReactNode;
  action?: React.ReactNode;
  smallTitle?: boolean;
  minicard?: boolean;
}

export const EDEmotionCardHeader: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { smallTitle, minicard, ...MuiProps } = props;
  return (
    <MuiCardHeader
      disableTypography
      sx={[
        {
          paddingTop: props.minicard ? 0 : 1,
          paddingLeft: 1,
          paddingBottom: 0,
          paddingRight: 0,
          '& .MuiCardHeader-action': { margin: 0 },
        },
      ]}
      {...MuiProps}
    />
  );
};
